<template>
  <div>
    <multiselect
      v-model="inputValue"
      :options="localOptions"
      @input="onChange"
      label="nome"
      track-by="id"
      :multiple="true"
      placeholder=""
      selectLabel=""
      selectedLabel="«"
      deselectLabel=""
      :allow-empty="isEmptySelectionAllowed"
      :loading="isLoading"
    >
      <template #placeholder>
        {{ customPlaceHolder }}
      </template>
      <template slot="noResult" slot-scope="props">
        <span>{{ $t('Nenhum elemento encontrado.') }}</span>
      </template>
      <template slot="noOptions" slot-scope="props">
        <span>{{ $t('Nenhum dado foi retornado.') }}</span>
      </template>
      <template slot="tag" slot-scope="{ option, remove }">
        <span class="badge badge-primary mr-1">
          <span class="text-truncate mr-1 mb-1">
            {{ option.nome }}
          </span>
          <span class="custom__remove badge" @mousedown.prevent.stop="remove(option)"> x </span>
        </span>
      </template>
    </multiselect>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
import { tiposTransacao } from '@/constants';
import i18n from '@/i18n';

export default {
  components: {
    Multiselect
  },
  props: {
    labelTitle: String,
    nameField: null,
    allowEmpty: Boolean,
    includeAll: Boolean,
    options: {
      type: Array,
      default: () => []
    }
  },
  emits: ['input', 'selectChange'],
  data() {
    return {
      inputValue: this.nameField,
      isLoading: false,
      initialItems: [],
      localOptions: [],
      _lastValidValue: null
    };
  },
  computed: {
    customPlaceHolder() {
      return this?.labelTitle ? this.$i18n.t(this.labelTitle) : '';
    },
    isEmptySelectionAllowed() {
      return this.allowEmpty || false;
    },
    defaultOptions() {
      return tiposTransacao.map((tipo) => ({
        ...tipo,
        nome: this.$i18n.t(tipo.nome)
      }));
    }
  },
  watch: {
    nameField() {
      this.inputValue = this.nameField;
    },
    options: {
      immediate: true,
      handler(newOptions) {
        this.localOptions = [];
        if (this.includeAll) {
          this.localOptions.push({ nome: this.$i18n.t(this.labelTitle), id: null });
        }

        const optionsToUse = newOptions?.length ? newOptions : this.defaultOptions;

        if (optionsToUse?.length) {
          this.localOptions.push(
            ...optionsToUse.map((e) => ({
              nome: e.nome,
              id: e.id
            }))
          );
        }

        if (this.localOptions?.length > 0 && !this.inputValue) {
          this.inputValue = [this.localOptions[0], this.localOptions[2]];
        }
        this.onChange(this.inputValue);
      }
    }
  },
  methods: {
    isValidCombination(selectedIds) {
      if (!selectedIds || selectedIds.length === 0) return true;
      if (selectedIds.length === 1) return true;

      const sortedIds = [...selectedIds].sort((a, b) => a - b);
      const validCombinations = [
        [1, 3],
        [2, 4]
      ];

      return validCombinations.some((combo) => JSON.stringify(sortedIds) === JSON.stringify(combo));
    },
    onChange(e) {
      if (e === null) {
        this.$emit('input', null);
        this.$emit('selectChange', 'id_tipo', null);
        return;
      }

      const selectedIds = e.map((item) => item.id);

      if (!this.isValidCombination(selectedIds)) {
        this.inputValue = this._lastValidValue || null;
        return;
      }

      this._lastValidValue = e;
      this.$emit('input', e);
      this.$emit('selectChange', 'id_tipo', e);
    },
    setValue() {
      this.inputValue = this.nameField;
    }
  }
};
</script>

<style lang="scss">
.multiselect-primary {
  .multiselect__tags {
    display: flex !important;
  }
}
</style>
